import { render, staticRenderFns } from "./PolizasAdministracionImportView.vue?vue&type=template&id=18891495&"
import script from "./PolizasAdministracionImportView.vue?vue&type=script&lang=js&"
export * from "./PolizasAdministracionImportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports